export const ADD_RECORD = 'ADD_RECORD';
export const UPDATE_RECORD = 'UPDATE_RECORD';
export const GET_RECORD = 'GET_RECORD';
export const DELETE_RECORD = 'DELETE_RECORD';
export const GET_RECORD_LIST = 'GET_RECORD_LIST';
export const RESET_RECORD = 'RESET_RECORD';
export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW';
export const RESET_WORKFLOW = 'RESET_WORKFLOW';

export function resetRecord() {
  return {
    type: RESET_RECORD,
  };
}

export function resetWorkflow() {
  return {
    type: RESET_WORKFLOW,
  };
}

/**
 * Add form record
 * @function addRecord
 * @param {String} form_id form id
 * @param {Object} data json record data
 * @param {String} state record state (draft, final)
 */
export function addRecord(form_id, data, state, pratica_report, params) {
  let payload = {
    form_id,
    data,
    state,
    pratica_report,
  };
  // add every param to payload
  if (params) {
    payload = { ...payload, ...params };
  }
  return {
    type: ADD_RECORD,
    request: {
      op: 'post',
      path: `/@pratica`,
      data: payload,
    },
  };
}

/**
 * Update existing pratica record
 * @function updateRecord
 * @param {Number} pratica_id record id
 * @param {Object} data json record data
 * @param {String} state record state (draft, final)
 */
export function updateRecord(
  pratica_id,
  data,
  state,
  assigned_to,
  pratica_report,
  params,
) {
  let payload = {
    data,
    state,
    pratica_report,
    assigned_to,
  };
  // add every param to payload
  if (params) {
    payload = { ...payload, ...params };
  }
  return {
    type: UPDATE_RECORD,
    request: {
      op: 'patch',
      path: `/@pratica/${pratica_id}`,
      data: payload,
    },
  };
}

/**
 * Get existing pratica record
 * @function getRecord
 * @param {Number} pratica_id record id
 */
export function getRecord(pratica_id, props) {
  const recordPath = pratica_id ? `/@pratica/${pratica_id}` : '/@pratica';
  return {
    type: GET_RECORD,
    request: {
      op: 'get',
      path: `${recordPath}?${new URLSearchParams(props).toString()}`,
    },
  };
}

/**
 * Update pratica state
 * @function updateState
 * @param {Number} pratica_id record id
 * @param {Object} data json record data
 * @param {String} state record state (draft, final)
 * @param {String} message optional message
 */
export function updateState(
  pratica_id,
  state,
  message,
  notify_on_email,
  attachments,
) {
  return {
    type: UPDATE_WORKFLOW,
    request: {
      op: 'post',
      path: `/@pratica-workflow/${pratica_id}`,
      data: {
        state,
        message: {
          pratica_id,
          message,
          notify_on_email,
          attachments,
        },
      },
    },
  };
}

/**
 * Delete existing pratica record
 * @function deleteRecord
 * @param {Number} pratica_id record id
 */
export function deleteRecord(pratica_id) {
  return {
    type: DELETE_RECORD,
    request: {
      op: 'delete',
      path: `/@pratica/${pratica_id}`,
    },
  };
}

/**
 * Delete existing pratica record
 * @function recordsList
 * param opzionali per l'aggiunta di filtri
 */
export function getRecordList(props) {
  return {
    type: GET_RECORD_LIST,
    request: {
      op: 'get',
      path: `/@pratiche?${new URLSearchParams(props).toString()}`,
    },
  };
}
